"use client";

import dynamic from "next/dynamic";
import { useState } from "react";

import type { MapProject } from "./map-project";
import ProjectMapLegend from "./ProjectMapLegend";

const MapLibreMap = dynamic(() => import("./MapLibreMap"), {
  ssr: false,
  loading: () => null,
});

export default function MapExperience({
  projects,
}: {
  projects: MapProject[];
}) {
  const [selectedProjectId, setSelectedProjectId] = useState<string | null>(null);
  const [selectedSectionId, setSelectedSectionId] = useState<string | null>(null);
  const [hoveredProjectId, setHoveredProjectId] = useState<string | null>(null);
  const [hoveredSectionId, setHoveredSectionId] = useState<string | null>(null);
  const selectProject = (projectId: string) => {
    setSelectedProjectId(projectId);
    setSelectedSectionId(null);
    setHoveredProjectId(null);
    setHoveredSectionId(null);
  };
  const showProjects = () => {
    setSelectedProjectId(null);
    setSelectedSectionId(null);
    setHoveredProjectId(null);
    setHoveredSectionId(null);
  };
  const selectSection = (sectionId: string) => {
    setSelectedSectionId(sectionId);
    setHoveredSectionId(null);
  };
  const showSectionList = () => {
    setSelectedSectionId(null);
    setHoveredSectionId(null);
  };

  return (
    <section aria-label="Map" className="relative h-full w-full">
      <MapLibreMap
        projects={projects}
        selectedProjectId={selectedProjectId}
        selectedSectionId={selectedSectionId}
        hoveredProjectId={hoveredProjectId}
        hoveredSectionId={hoveredSectionId}
        onSelectProject={selectProject}
        onSelectSection={selectSection}
        onHoverProject={setHoveredProjectId}
        onHoverSection={setHoveredSectionId}
      />
      <ProjectMapLegend
        projects={projects}
        selectedProjectId={selectedProjectId}
        selectedSectionId={selectedSectionId}
        hoveredProjectId={hoveredProjectId}
        hoveredSectionId={hoveredSectionId}
        onSelectProject={selectProject}
        onSelectSection={selectSection}
        onBack={showProjects}
        onBackToSections={showSectionList}
        onHoverProject={setHoveredProjectId}
        onHoverSection={setHoveredSectionId}
      />
    </section>
  );
}